import React from "react";
import { Link } from "react-router-dom";
import Slider from "../Slider/Slider";
import "./HomeSlider.css";


const HomeSlider = ({ sliders }) => {


    if (!sliders || sliders.length === 0) {
        return null;
    }



    const renderSlideLink = (item, children) => {

        const link = item?.link?.trim();


        if (!link) {
            return children;
        }


        // External link

        if (
            link.startsWith("http://") ||
            link.startsWith("https://")
        ) {

            return (

                <a
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="slider-image-link"
                >
                    {children}
                </a>

            );

        }



        // Internal route

        if (link.startsWith("/")) {

            return (

                <Link
                    to={link}
                    className="slider-image-link"
                >
                    {children}
                </Link>

            );

        }


        return children;

    };




    return (

        <section className="home-slider-wrapper">


            <Slider
                autoPlay={true}
                showButtons={true}
                showDots={true}
                interval={4000}
            >


                {
                    sliders.map((item, index) => (

                        <div
                            className="home-slide"
                            key={item._id || index}
                        >


                            {
                                renderSlideLink(
                                    item,
                                    <img
                                        src={item.image}
                                        alt={item.name || "Home banner"}
                                        className="slider-image"
                                        loading={index === 0 ? "eager" : "lazy"}
                                    />
                                )
                            }


                        </div>

                    ))
                }


            </Slider>

        </section>

    );

};


export default HomeSlider;